import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-medication-finder-banner',
  templateUrl: './medication-finder-banner.component.html',
  styleUrls: ['./medication-finder-banner.component.scss'],
})
export class MedicationFinderBannerComponent {
  @Output() public linkClick = new EventEmitter<void>();

  constructor(public translateService: TranslateService) {}
}
